import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'

import mutations from './mutations'
import getters from './getters'
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        visit:
        {
            key: undefined,
            objectTitle: '',
            objectLatitude: 0.000,
            objectLongitude: 0.000,
            objectStatus: undefined,
            userStatus: undefined,
            userLatitude: 0.000,
            userLongitude: 0.000,
        },
    },
    mutations,
    getters
})
